export const LIST = "EMAIL_OTP_LIST";